module.exports = __webpack_public_path__ + "img/bilibili.28c696f7.png";